import { useEffect, useRef } from "react";

export const usePrevious = <T extends unknown>(value: T): T | undefined => {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  //   TODO: Remove me later, this is to trigger the deploy"
  return ref.current;
};
